import React from 'react';

interface ServiceCardProps {
  title: string;
  items: string[];
  icon: React.ReactNode;
}

const ServiceCard: React.FC<ServiceCardProps> = ({ title, items, icon }) => {
  return (
    <div className="bg-gray-800 rounded-xl p-4 md:p-6 shadow-lg hover:shadow-purple-500/10 transition-all">
      <div className="flex items-center mb-3 md:mb-4 text-purple-400">
        {icon}
        <h3 className="text-lg md:text-xl font-semibold text-white ml-3">{title}</h3>
      </div>
      <ul className="space-y-2 text-sm md:text-base text-gray-300">
        {items.map((item: string, index: number) => (
          <li key={index} className="flex items-start">
            <svg className="w-4 h-4 md:w-5 md:h-5 text-purple-400 mr-2 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            {item}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ServiceCard; 